import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

import RenderFile from 'src/components/RenderFile';
import { toast } from 'react-toastify';
import classNames from 'classnames';
import styles from './assets/dropzone.module.scss';

interface IDropzoneField {
    files: any;
    validatePhoto?: boolean;
    validatePdf?: boolean;
    download?: boolean;
    disabled?: boolean;
    single?: boolean;
    setFiles: (it: any) => void;
    removeFile?: (id: string | number) => void;
    typeDropZone?: string;
    fieldDZInformation?: boolean;
    typeViewFiles?: 'normal' | 'forService';
}
export const DropZoneField: React.FunctionComponent<IDropzoneField> = (props: IDropzoneField) => {
    const { typeViewFiles = 'normal' } = props;

    const onDrop = useCallback(
        (acceptedFiles: any) => {
            if (!Array.isArray(props.files)) {
                props.setFiles(acceptedFiles[0]);
            } else {
                const fil: any = props.files.concat(acceptedFiles);
                props.setFiles(fil);
            }

            acceptedFiles.forEach((file: any) => {
                const reader = new FileReader();

                reader.onabort = () => console.log('file reading was aborted');

                reader.onerror = () => console.log('file reading has failed');
                reader.onload = () => {
                    // Do whatever you want with the file contents
                    //const binaryStr = reader.result;
                };
                reader.readAsArrayBuffer(file);
            });
        },

        // eslint-disable-next-line
        [props.files],
    );
    let accept = {};
    if (props.validatePhoto) {
        accept = { accept: 'image/jpeg, image/png' };
    }
    if (props.validatePdf) {
        accept = { accept: '.pdf, application/pdf' };
    }
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        ...accept,
        maxSize: 30000000,
        onDropRejected: (...args) => {
            toast.error('Not acceptable file');
        },
    });
    let renderFiles = props.files;
    if (!Array.isArray(renderFiles)) {
        renderFiles = props.files ? [props.files] : [];
    }

    const previewFiles = renderFiles.map((file: any, i: number) => (
        <li style={{ listStyleType: 'none' }} key={`file.path-${i}`}>
            <RenderFile
                download={props.download}
                file={file}
                number={i}
                removeFile={props.removeFile}
                typeViewFiles={typeViewFiles}
            />
        </li>
    ));
    //validatePdf
    let desct = 'Types: pdf, images, csv, excel, txt, doc';
    if (props.validatePhoto) {
        desct = 'Type: images';
    }
    if (props.validatePdf) {
        desct = 'Type: PDF';
    }

    return (
        <section className={classNames(styles.dropZoneContainer)}>
            {props.fieldDZInformation && (
                <div className={classNames(styles.types)}>
                    <span>{desct} | </span>
                    <span>Max Size: 30Mb</span>
                </div>
            )}
            {props.single ? (
                <div {...getRootProps({ className: 'dropzone' })} className={classNames(styles.dropZoneOne)}>
                    <input disabled={props.disabled} {...getInputProps()} />
                    <p className={'dropZone-title'}>
                        Drag drop file here, or click to select it{' '}
                        <span>
                            <span>
                                <span>
                                    <span>
                                        <span></span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </p>
                    <span>
                        <span>
                            <span>
                                <span>
                                    <span></span>
                                </span>
                            </span>
                        </span>
                    </span>
                </div>
            ) : (
                <div
                    {...getRootProps({ className: 'dropzone' })}
                    className={classNames(props.typeDropZone === 'main' ? styles.dropZone : styles.dropZoneMain)}
                >
                    <input {...getInputProps()} />
                    <p className={'dropZone-title'}>
                        Drag drop files here, or click to select them{' '}
                        <span>
                            <span>
                                <span>
                                    <span>
                                        <span></span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </p>
                    <span>
                        <span>
                            <span>
                                <span>
                                    <span></span>
                                </span>
                            </span>
                        </span>
                    </span>
                </div>
            )}
            <aside>
                <ul className={classNames(typeViewFiles === 'forService' ? styles.dropZoneListS : styles.dropZoneList)}>
                    {previewFiles}
                </ul>
            </aside>
        </section>
    );
};
